import { StyleSheet, Text, View, Image, TouchableOpacity, Animated } from 'react-native'
import { ThemedText, ThemedView } from '@app/theme';
import RadioV2 from '@app/sharedComponents/RadioV2/RadioV2';
import { useRef } from 'react';
import { useEffect } from 'react';
import { trackEvent } from '@app/utils/amplitude';
import { DefaultRTA } from '@app/types';


const RtaSelectionCard = ({ 
    rta, 
    isSelected, 
    onSelect,
    defaultRTAData,
    height = undefined
}: { 
    rta: DefaultRTA, 
    isSelected: boolean, 
    onSelect: (rta: DefaultRTA[]) => void ,
    defaultRTAData: DefaultRTA[],
    height?: number
}) => {

  const opacity = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    Animated.timing(opacity, {
      toValue: 1,
      duration: 500,
      useNativeDriver: true,
    }).start();
  }, []);
  
  return (
    <Animated.View style={{ opacity }}>
      <TouchableOpacity onPress={() => {
        onSelect(defaultRTAData?.map((item: DefaultRTA) => ({...item, defaultRta: item.assetRepository === rta.assetRepository})))
      }}
      >
        <ThemedView 
            padding='md' 
            flexDirection='row' 
            borderWidth={1} 
            borderColor={isSelected ? 'bg-action-primary' : 'border-primary'} 
            mb='md' 
            borderRadius='sm' 
            alignItems='center'
            height={height}
            backgroundColor={isSelected ? 'bg-fill-emphasis-primary-1': 'white'}
        >
            <ThemedView style={{}}>
                <RadioV2 isSelected={isSelected} />
            </ThemedView>
            <ThemedView style={{marginLeft: 12}}/>
            <ThemedView style={{ flex: 1 }}>
                <ThemedView flexDirection='row'>
                    <ThemedText variant='b3r' color='text-primary' fontWeight='600'>{rta.repositoryName}</ThemedText>
                    {
                        rta.recommendedRta && (
                            <ThemedView borderWidth={1} borderColor='border-emphasis-secondary' bg='bg-fill-emphasis-secondary' style={{ paddingVertical: 2, paddingHorizontal: 8, borderRadius: 4, marginLeft: 8 }}>
                                <ThemedText variant='b5r' color='text-emphasis-secondary'>Recommended</ThemedText>
                            </ThemedView>
                        )
                    }
                </ThemedView>
                {
                    rta.assetRepository === 'MFCENTRAL' &&
                    <ThemedText variant='b4r' color='text-secondary'>Fetch your complete portfolio with just one OTP</ThemedText>
                }
            </ThemedView>
        </ThemedView>
      </TouchableOpacity>
    </Animated.View>
  )
}

export default RtaSelectionCard

const styles = StyleSheet.create({})